import { RadioGroup, RadioGroupItem } from "../../../../components/ui/common/radio-group";

const SORT_OPTIONS = [
  { value: 1, label: "With calculation" },
  { value: 2, label: "Without calculation" },
  { value: 3, label: "Not relevant" }
] as const;

interface FilterSortOptionsProps {
  sortBy: number;
  onChange: (value: number) => void;
}

const FilterSortOptions = ({ sortBy, onChange }: FilterSortOptionsProps) => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-2">
      <p className="tw-text-sm tw-font-medium tw-text-foreground">Sort Result</p>
      <RadioGroup
        value={String(sortBy)}
        onValueChange={value => onChange(Number(value))}
        className="tw-flex tw-flex-col tw-gap-2"
      >
        {SORT_OPTIONS.map(option => (
          <label
            key={option.value}
            className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-text-sm tw-text-foreground"
          >
            <RadioGroupItem value={String(option.value)} />
            {option.label}
          </label>
        ))}
      </RadioGroup>
    </div>
  );
};

export default FilterSortOptions;
